/*@ngInject*/
const FilesAndIconsManagerModel = function () {

    let configuredFiles = {},
        hasUnsavedChanges = false,
        modifiedFileOrIcons = [];

    this.getConfiguredFiles = function () {
        return configuredFiles;
    };

    this.setConfiguredFiles = function (value) {
        configuredFiles = value;
    };

    this.setUnsavedChanges = function (value) {
        hasUnsavedChanges = value;
    };

    this.hasUnsavedChanges = function () {
        return hasUnsavedChanges;
    };

    this.getModifiedFileOrIcons = function () {
        return modifiedFileOrIcons;
    };

    this.addToModifiedFileOrIcons = function(modifiedFileOrIcon) {
        modifiedFileOrIcons.push(modifiedFileOrIcon);
    };

    this.removeFromModifiedFileOrIcons = function(modifiedFileOrIcon) {
        _.remove(modifiedFileOrIcons, function(item) {
            return item.id === modifiedFileOrIcon.id || item.rowId === modifiedFileOrIcon.rowId;
        });
    };

    this.resetModifiedFileOrIcons = function() {
        modifiedFileOrIcons = [];
    };
};

angular.module('ums.configuration')
    .service('filesAndIconsManagerModel', FilesAndIconsManagerModel);
